export const PRODUCT_BADGE_COLORS = ['red', 'yellow', 'black'] as const;
export const PRODUCT_BADGE_ICONS = ['star', 'tag', 'bestseller'] as const;
export const PRODUCT_BADGE_POSITIONS = ['top-left', 'top-right'] as const;
/** The "Badge type" value of the product rule badge for Nuki Club only items. */
export const CLUB_EXCLUSIVE_BADGE_KEY = 'club-exclusive';

export type ProductBadgeColor = (typeof PRODUCT_BADGE_COLORS)[number];
export type ProductBadgeIcon = (typeof PRODUCT_BADGE_ICONS)[number];
export type ProductBadgePosition = (typeof PRODUCT_BADGE_POSITIONS)[number];

/** A badge shown on a product, variant or bundle image and offered as an overview filter. */
export interface ProductBadgeModel {
  /** Stable key for filtering: the badge type, or the name when no type is set. */
  key: string;
  /** Text on the badge and of the overview filter. */
  label: string;
  /** No colour means the default look. */
  color?: ProductBadgeColor;
  icon?: ProductBadgeIcon;
  position: ProductBadgePosition;
}
